export default function TwitterIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        d="M18.9014 1.625H22.5816L14.5415 10.8381L24 23.375H16.5941L10.7935 15.7714L4.15631 23.375H0.473926L9.07356 13.5206L0 1.625H7.59394L12.8372 8.57496L18.9014 1.625ZM17.6098 21.1665H19.649L6.48588 3.71746H4.29759L17.6098 21.1665Z"
        fill="#8897AE"
      />
    </svg>
  );
}
